// import React from 'react';
import $ from 'jquery';

window.jQuery=window.$ = $;

const quc = $.getScript('//s.ssl.qhimg.com/quc/quc6.js');

export default quc;
